import React from 'react';
import { Container, Card } from '../design-system';
import { Cog, Plug, Cloud, Rocket, LifeBuoy, CreditCard } from 'lucide-react';

export function Features() {
  const features = [
    {
      icon: Cog,
      title: 'Sistemas Personalizados',
      description: 'Soluções sob medida alinhadas ao seu negócio e aos seus processos.'
    },
    {
      icon: Plug,
      title: 'Integrações',
      description: 'Conectamos sistemas, APIs e serviços para fluxos automatizados e escaláveis.'
    },
    {
      icon: Cloud,
      title: 'Backups & Resiliência',
      description: 'Políticas de backup, recuperação e alta disponibilidade para manter tudo seguro.'
    },
    {
      icon: Rocket,
      title: 'Foco na Entrega',
      description: 'Planejamento claro, sprints objetivos e resultados mensuráveis em cada etapa.'
    },
    {
      icon: LifeBuoy,
      title: 'Observabilidade & Suporte',
      description: 'Monitoramento, alertas e suporte proativo para manter o sistema saudável.'
    },
    {
      icon: CreditCard,
      title: 'Pagamentos & Compliance',
      description: 'Integração com gateways, antifraude e boas práticas de segurança e conformidade.'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <Container maxWidth="xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Por que escolher a Gruty?
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Resolvemos problemas reais com soluções digitais, de forma organizada, objetiva e segura.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} hover className="group">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-5 group-hover:bg-indigo-600 transition-colors">
                    <Icon className="w-8 h-8 text-indigo-600 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600">
                    {feature.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
